import { storyblokEditable } from "@storyblok/react";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { useRouter } from "next/compat/router";
import { useCurrentUser } from "@hooks/use-current-user";
import Link from "@components/core/Link";
import { StoryblokPicture } from "@components/core/Storyblok/StoryblokImage";
import Button from "@components/core/Button";

function MediumBanner({ blok }) {
  const router = useRouter();
  const user = useCurrentUser();
  const userGroup = user?.user_group;

  function sendTrackerData() {
    const defaultEventData = {
      tracking_name: "homeMediumBanner",
      page: router?.asPath,
      link: blok.link?.url,
      user_group: userGroup,
    };

    ahoy("$click", defaultEventData);
    analytics.track("$click", defaultEventData);
  }

  if (!blok) return null;

  return (
    <section
      key={blok._uid}
      {...storyblokEditable(blok)}
      className="medium-banner-container"
    >
      <Link
        href={blok.link?.url}
        prefetch={false}
        onClick={() => sendTrackerData()}
        className="medium-banner-link"
      >
        <StoryblokPicture
          className="medium-banner-image"
          desktopSrc={blok.background_image_desktop?.filename}
          mobileSrc={blok.background_image_mobile?.filename}
        />
        {blok.button_title && (
          <div className="medium-banner-btn-container">
            <Button variant="ghost-primary">{blok.button_title}</Button>
          </div>
        )}
      </Link>
    </section>
  );
}

export default MediumBanner;
